(function($) {
    let $carousel = $(".js-carousel");
    if (!$carousel.length) return;

    $carousel.waterwheelCarousel({
        separation: 250,
        // separationMultiplier: 0.7,
        sizeMultiplier: 0.5,
        opacityMultiplier: 0.65,
        speed: 400,
        animationEasing: "swing",
        autoPlay: 6000,
        movedToCenter: function($item) {
                $('.js-carousel__controls .carousel__button').removeClass('is-active');
                $('.js-carousel__controls').find('.' + $item.data('control')).addClass('is-active');
            }
            // imageNav: false,
            // linkHandling: 1,
            // quickerForFurther: false,
    });

    $('.js-carousel__button').click(function(e) {
        e.preventDefault();
        $(".js-carousel .carousel__item").eq($(this).data("order")).click();
    });

    // var carousel = $("#carousel").waterwheelCarousel({
    //         flankingItems: 3,
    //         separation: 250,
    //         movedToCenter: function ($item) {
    //             $('.carousel-btn .ellipse').removeClass('active');
    //             $('.carousel-btn').find('.'+$item.attr('id')).addClass('active');
    //         }
    //     });

    //     //кнопки под каруселью
    //     $('.ellipse').on('click', function(e){
    //         e.preventDefault();
    //         $('#carousel img').eq($(this).data('itemId')-1).click();
    //     });

    // $carousel.carousel({
    //     carouselWidth: 1132,
    //     carouselHeight: 580,
    //     directionNav: false,
    //     reflection: false,
    //     shadow: false,
    //     buttonNav: 'bullets',
    //     backOpacity: 0.5,
    // });
})(jQuery);



// WEBPACK FOOTER //
// ./common.blocks/carousel/carousel.js